import React, { useState, useEffect, useCallback } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { setLoading } from "../../../../store/slices/loaderSlice";
import {
  getData,
  patchData,
  patchFormData,
  postData,
  postFormData,
} from "../../../../services";
import View from "../../../icons/View";
import Edit from "../../../icons/Edit";
import Delete from "../../../icons/Delete";
import More from "../../../icons/More";
import VerticalMenu from "../../../icons/VerticalMenu";
import { useDelete } from "../../../../hooks/useDelete";
import NoContentCard from "../../../atoms/NoContentCard";
import NoContentIcon from "../../../icons/NocontentIcon";
import PageHeader from "../../../atoms/PageHeader";
import PageCard from "../../../atoms/PageCard";
import Search from "../../../molecules/search";
import CustomButton from "../../../atoms/CustomButton";
import CustomDatagrid from "../../../molecules/CustomDatagrid";
import DeleteModal from "../../../organisms/modals/DeleteModal";
import Pagination from "../../../molecules/Pagination";
import toast from "react-hot-toast";
import { errorStyles } from "../../../molecules/Dropdown/dropdown";
import DateRangePicker from "../../../organisms/dateRangePicker";
import { Menu, MenuItem } from "@mui/material";
import { confimationStyles } from "../../../../assets/styles/toast";
import { statusInvites } from "../../../../helpers/staticData";

import moment from "moment";
import FilterComponent from "../../../organisms/filters/FilterComponent";
import { getVenueList } from "../../../../services/basicGets";
import useScreenWidth from "../../../../hooks/useScreenwidth";
import addMonths from "date-fns/addMonths";
import { getEmployeeVenueList } from "../../../../services/basicGets";
import QRCode from "qrcode";
import {
  startOfMonth,
  endOfMonth,
  addDays,
  addHours,
  startOfDay,
} from "date-fns";
import QrCode from "../../../icons/qrcode";
import "./styles.scss";
import { base64ToFile } from "../../../../helpers/base64ToFile";
import { set } from "rsuite/esm/internals/utils/date";
import HorizontalMenu from "../../../icons/HorizontalMenu";
import Cancel from "../../../icons/Cancel";
import Resend from "../../../icons/Resend";
import Confirm from "../../../icons/Confirm";

const Plans = ({ mode }) => {
  const defaultToday = new Date();
  const navigate = useNavigate();
  const screenWidth = useScreenWidth();
  const [cookies] = useCookies(["b_t", "bid", "buid", "mode"]);
  const [tableData, setTableData] = useState([]);
  const [searchedValue, setSearchedValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [date, setDate] = useState({
    start_date: addHours(startOfDay(startOfMonth(defaultToday)), 12),
    end_date: addHours(startOfDay(endOfMonth(defaultToday)), 12),
  });
  const [filters, setFilters] = useState({});
  const [venueData, setVenueData] = useState([]);
  const [modalState, setModalState] = useState({
    isDeleteModalOpen: false,
    modalId: "",
    name: "",
    isViewModalOpen: false,
    data: null,
  });
  const [modalStateQR, setModalStateQR] = useState({
    isQRModalOpen: false,
    data: null,
  });
  const [anchorEl, setAnchorEl] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState([]);
  const [selectedRow2, setSelectedRow2] = useState(null);

  // Function to handle opening menu for a specific row
  const handleStatusMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  // Function to close menu for a specific row
  const handleCloseMenu = (index) => {
    setAnchorEl(null);
  };
  const handleStatusMenu2 = (event, row) => {
    setAnchorEl2(event.currentTarget);
    setSelectedRow2(row);
  };

  // Function to close menu for a specific row
  const handleCloseMenu2 = (index) => {
    setAnchorEl2(null);
  };

  useEffect(() => {
    (async () => {
      let res;
      if (mode === "Employee") {
        res = await getEmployeeVenueList({
          emp_id: cookies.buid,
          token: cookies.b_t,
        });
      } else {
        res = await getVenueList({
          business_id: cookies.bid,
          token: cookies.b_t,
        });
      }
      setVenueData(res);
    })();
  }, []);

  const getAllInvites = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getData({
        endpoint: "Invite/getAllInvitesByBusinessId",
        params: {
          search_query: searchedValue,
          page: currentPage,
          page_limit: itemsPerPage,
          business_id: cookies.bid,
          employee_id:
            atob(cookies.mode || "") === "Employee" ? cookies.buid : null,
          venues:
            filters?.Venues?.length > 0
              ? JSON.stringify(filters?.Venues)
              : null,
          status:
            filters?.Status?.length > 0
              ? JSON.stringify(filters?.Status)
              : null,
          start_date: date.start_date,
          end_date: date.end_date,
        },
        token: cookies.b_t,
      });

      if (res) {
        setTableData(res);
      }
    } catch (error) {
      console.error(error); // Use console.error for errors
    }
  }, [searchedValue, cookies.b_t, currentPage, itemsPerPage, filters, date]);

  const generateQrCode = async (string) => {
    try {
      const url = await QRCode.toDataURL(string);
      const finalQr = base64ToFile(url);

      return finalQr;
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdate = async (id, status, value) => {
    const requestData = {
      endpoint: "Invite/editStatus",
      params: {
        id: id,
        status: status,
      },
      headerType: mode,
    };

    if (status === "Confirmed") {
      const qr = await generateQrCode(value.bar_code);
      requestData.data = {
        qr_image: qr,
      };
    } else {
      requestData.data = {
        qr_image: null,
      };
    }
    try {
      const res = await patchFormData(requestData);

      if (res) {
        toast.success("Status Updated Successfully", {
          duration: 1000,
          style: confimationStyles,
        });
        getAllInvites();
      }
    } catch (error) {
      console.log("error", error);
      toast.error("An Error Occured", { duration: 1000, style: errorStyles });
    }
  };

  const handleResend = async (value) => {
    const qr = await generateQrCode(value.bar_code);

    try {
      const res = await postFormData({
        endpoint: "Invite/resendInvitation",
        params: {
          invite_id: value.id,
        },
        data: {
          qr_image: qr,
        },
        headerType: mode,
        token: cookies.b_t,
      });

      if (res) {
        toast.success("Invitation Resended Successfully", {
          duration: 1000,
          style: confimationStyles,
        });
        getAllInvites();
      }
    } catch (error) {
      console.log("error", error);
      toast.error("An Error Occured", { duration: 1000, style: errorStyles });
    }
  };

  const handleQRCode = async (id) => {
    setModalStateQR({
      isQRModalOpen: true,
      data: id,
    });
  };

  const handleDeletionQR = async (id) => {
    try {
      const res = await postData({
        endpoint: "Invite/revokePermanentQR",
        params: {
          invite_id: id,
        },
        headerType: mode,
        token: cookies.b_t,
      });

      if (res) {
        toast.success("QR Revoked successfully", {
          duration: 1000,
          style: confimationStyles,
        });
        getAllInvites();
      }
    } catch (error) {
      console.log("error", error);
      toast.error("An Error Occured", { duration: 1000, style: errorStyles });
    } finally {
      setModalStateQR({
        isQRModalOpen: false,
        data: null,
      });
    }
  };

  useEffect(() => {
    getAllInvites();
  }, [getAllInvites]);
  const columns = [
    {
      field: "venue_name",
      headerName: "Venue Name",
      ...(screenWidth < 1230 ? { width: 200 } : { flex: 1 }),
      sortable: true,
    },
    {
      field: "invitee_name",
      headerName: "Invitee Name",
      ...(screenWidth < 1230 ? { width: 200 } : { flex: 1 }),
      sortable: true,
      renderCell: (params) => {
        return <span className="line-truncate">{params.row.invitee_name}</span>;
      },
    },
    {
      field: "host_name",
      headerName: "Host Name",
      ...(screenWidth < 1230 ? { width: 200 } : { flex: 1 }),
      sortable: true,
    },
    {
      field: "contact_details",
      headerName: "Contact Details",
      ...(screenWidth < 1230 ? { width: 150 } : { flex: 1.5 }),
      sortable: true,
      renderCell: (params) => {
        return (
          <div className="d-flex flex-column w-100">
            <span>
              {params.row.phone_number && params.row.country_code}{" "}
              {params.row.phone_number}
            </span>
            <span
              style={{ overflow: "hidden", textOverflow: "ellipsis" }}
              title={params.row.email}
            >
              {params.row.email}
            </span>
          </div>
        );
      },
    },
    {
      field: "address",
      headerName: "Address",
      ...(screenWidth < 1230 ? { width: 200 } : { flex: 1 }),
      sortable: true,
      renderCell: (params) => {
        return <span className="line-truncate">{params.row.address}</span>;
      },
    },
    {
      field: "company",
      headerName: "Company",
      ...(screenWidth < 1230 ? { width: 200 } : { flex: 1 }),
      sortable: true,
      renderCell: (params) => {
        return <span className="line-truncate">{params.row.company}</span>;
      },
    },
    {
      field: "start_time",
      headerName: "Time For Meeting",
      ...(screenWidth < 1230 ? { width: 200 } : { flex: 1.5 }),
      sortable: true,
      renderCell: (params) => {
        return (
          <span>
            {moment.utc(params.row?.date).format("DD/MM/YYYY")}{" "}
            {params?.row.start_time
              ? moment
                  .utc(params?.row.start_time, "HH:mm:ss")
                  .local()
                  .format("hh:mm A")
              : "--"}
          </span>
        );
      },
    },

    {
      field: "status",
      headerName: "Status",
      ...(screenWidth < 1230 ? { width: 120 } : { flex: 0.8 }),
      renderCell: (params) => {
        const status = {
          Confirmed: "text-success",
          Cancelled: "text-error",
          Unheld: "text-grey",
          Completed: "text-darkGreen",
          Ongoing: "text-warning",
        };
        return (
          <>
            <span className={`${status[params.row.status]} fw-bold`}>
              {params?.row?.status}
            </span>
          </>
        );
      },
    },
    {
      headerName: "Action",
      ...(screenWidth < 1230 ? { width: 130 } : { flex: 0.9 }),
      renderCell: (params) => {
        return (
          <>
            {params.row.status !== "Completed" &&
              params.row.status !== "Ongoing" && (
                <div className="table-icons-container">
                  {/* Vertical menu icon */}

                  {params.row.status !== "Unheld" && (
                    <div
                      onClick={(event) => handleStatusMenu(event, params.row)}
                    >
                      <HorizontalMenu />
                    </div>
                  )}

                  {/* Menu with status options */}
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl) && selectedRow === params.row}
                    onClose={() => handleCloseMenu()}
                    PaperProps={{
                      style: {
                        width: "160px",
                        borderRadius: "16px",
                        marginTop: "10px", // Add margin-top to create space
                        boxShadow: "0px 4px 14px 0px rgba(0, 0, 0, 0.015)", // Aesthetically pleasing box shadow
                        border: "1px solid #efefef",
                        fontWeight: "500",
                        fontSize: "14px", // Corrected typo in fontSize
                      },
                    }}
                  >
                    <MenuItem onClick={() => navigate(`edit/${params.row.id}`)}>
                      <div className="d-flex gap-2 align-items-center">
                        <Edit /> Edit
                      </div>
                    </MenuItem>
                    <MenuItem onClick={() => handleDeleteModal(params.row)}>
                      <div className="d-flex gap-2 align-items-center">
                        <Delete /> Delete
                      </div>
                    </MenuItem>

                    {params.row.status !== "Confirmed" && (
                      <>
                        {params.row.status !== "Cancelled" && (
                          <MenuItem
                            onClick={() => {
                              setAnchorEl(null);
                              handleUpdate(
                                params.row.id,
                                "Confirmed",
                                params.row
                              );
                            }}
                          >
                            <div className="d-flex gap-2 align-items-center">
                              <Confirm />
                              Confirm
                            </div>
                          </MenuItem>
                        )}
                        <MenuItem
                          onClick={() => {
                            setAnchorEl(null);
                            handleResend(params.row, "Confirmed");
                          }}
                        >
                          <div className="d-flex gap-2 align-items-center">
                            <Resend />
                            Resend Invite
                          </div>
                        </MenuItem>
                      </>
                    )}
                    {params.row.status !== "Cancelled" && (
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          handleUpdate(params.row.id, "Cancelled");
                        }}
                      >
                        <div className="d-flex gap-2 align-items-center">
                          <Cancel fill="#BE0F00" />
                          <span style={{ color: "#BE0F00" }}>Cancel</span>
                        </div>
                      </MenuItem>
                    )}
                  </Menu>
                </div>
              )}
            {params.row.status === "Completed" &&
              params.row.is_permanent_qr_active && (
                <>
                  <div
                    onClick={(event) => handleStatusMenu2(event, params.row)}
                  >
                    <HorizontalMenu />
                  </div>
                  <Menu
                    anchorEl={anchorEl2}
                    open={Boolean(anchorEl2) && selectedRow2 === params.row}
                    onClose={() => handleCloseMenu2()}
                    PaperProps={{
                      style: {
                        width: "160px",
                        borderRadius: "16px",
                        marginTop: "10px", // Add margin-top to create space
                        boxShadow: "0px 4px 14px 0px rgba(0, 0, 0, 0.015)", // Aesthetically pleasing box shadow
                        border: "1px solid #efefef",
                        fontWeight: "500",
                        fontSize: "14px", // Corrected typo in fontSize
                      },
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        setAnchorEl2(null);
                        handleQRCode(selectedRow2.id);
                      }}
                    >
                      <div className="d-flex gap-2 align-items-center">
                        <QrCode /> Revoke QR
                      </div>
                    </MenuItem>
                  </Menu>
                </>
              )}
          </>
        );
      },
    },
  ];
  const deleteInvite = useDelete(mode);

  const handleDeleteModal = (data) => {
    setModalState((prevState) => ({
      ...prevState,
      isDeleteModalOpen: true,
      modalId: data.id,
      name: data.name,
    }));
  };
  const handleDeletion = async () => {
    try {
      await deleteInvite("Invite/deleteInvite", "Invite", {
        id: modalState.modalId,
      });
      getAllInvites();
      setModalState((prevState) => ({
        ...prevState,
        isDeleteModalOpen: false,
      }));
    } catch (error) {
      toast.error("An Error Occured While Deleting", {
        style: errorStyles,
        duration: 1000,
      });
    }
  };

  const CustomNoRowsOverlay = React.memo(() => {
    return (
      <>
        {!!searchedValue ? (
          <NoContentCard
            title="No Record Found"
            type="Company"
            icon={<NoContentIcon />}
            small={true}
          />
        ) : (
          <NoContentCard
            title="No Invites Created Yet!"
            subtitle="Click on Create Invite button to create a invite"
            tag="Create Invite"
            handleClick={() => navigate("add")}
            type="Company"
            icon={<NoContentIcon />}
            small={true}
          />
        )}
      </>
    );
  });

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  // Handle items per page change
  const handleItemsPerPageChange = useCallback((perPage) => {
    setCurrentPage(1);
    setItemsPerPage(perPage);
  }, []);

  const filtersData = {
    Venues: venueData,
    Status: statusInvites,
  };
  return (
    <>
      <PageHeader title="Meeting Schedule">
        <DateRangePicker type="header-filter" setDate={setDate} />
      </PageHeader>
      <PageCard>
        <div className="d-flex w-100 mb-2 justify-content-between">
          <Search
            onSearchEmit={(value) => {
              setSearchedValue(value);
              if (value.length > 2) {
                if (currentPage !== 1) setCurrentPage(1);
              }
            }}
            placeholder="Search By Invitee Name"
          />

          <div className="d-flex gap-2">
            <FilterComponent
              filterData={filtersData}
              onFilterChange={(filters) => {
                setFilters(filters);
              }}
            />

            <CustomButton
              text="Create Invite"
              type="btn-primary"
              handleClick={() => navigate("add")}
            />
          </div>
          {/* <DateRangePickerShortCuts setDate={setDate} /> */}
        </div>

        <CustomDatagrid
          getRowId={(row) => row.id}
          rows={tableData?.data || []}
          columns={columns}
          CustomNoRowsOverlay={CustomNoRowsOverlay}
          height={() => 70}
        />
        {tableData?.total_record > 25 && (
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={tableData?.total_record}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        )}
        {modalState.isDeleteModalOpen && (
          <DeleteModal
            name={modalState.name}
            id={modalState.modalId}
            isActive={modalState.isDeleteModalOpen}
            onClose={() =>
              setModalState((prevState) => ({
                ...prevState,
                isDeleteModalOpen: false,
              }))
            }
            title="Invite"
            onClick={handleDeletion}
          />
        )}
        {modalStateQR.isQRModalOpen && (
          <DeleteModal
            name={modalState.name}
            isActive={modalStateQR.isQRModalOpen}
            onClose={() =>
              setModalStateQR((prevState) => ({
                ...prevState,
                isQRModalOpen: false,
                data: null,
              }))
            }
            description="Visitors will no longer be able to check in or check out using a QR code or invite code. Are you sure you want to revoke it?"
            title="Revoke QR"
            type=""
            onClick={() => handleDeletionQR(modalStateQR.data)}
          />
        )}
      </PageCard>
    </>
  );
};

export default Plans;
